import axios from 'axios';
import { Config } from '../../config/config';

let _headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

let _authInterceptor;

let axiosInstance = axios.create({
  baseURL: Config.apiUrl + Config.apiVersion,
  headers: _headers,
});

const cleanApi = () => {
  axiosInstance = axios.create({
    baseURL: Config.apiUrl + Config.apiVersion,
    headers: _headers,
  });
};
const addErrorInterceptor = ({errorCode, fn}) => {
  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      if (errorCode === error.response?.status) {
        fn && fn();
      }
      return Promise.reject(error);
    }
  );
};

const get = (path, config) => {
  return axiosInstance.get(path, config);
};

const post = (path, data, config) => {
  return axiosInstance.post(path, data, config);
};

const put = (path, data, config) => {
  return axiosInstance.put(path, data, config);
};

const patch = (path, data, config) => {
  return axiosInstance.patch(path, data, config);
};

const deleteRequest = (path, config) => {
  return axiosInstance.delete(path, config);
};

const setAuth = ({token}) => {
  //const session = store.getState().session.data;
  const auth = token || token;
  removeAuth();
  _authInterceptor = axiosInstance.interceptors.request.use(request => {
    request.headers['Authorization'] = `Bearer ${auth}`;
    return request;
  });
};

const removeAuth = () => {
  axiosInstance.interceptors.request.eject(_authInterceptor);
};

const pureInstance = () =>
  axios.create({
    baseURL: Config.apiUrl + Config.apiVersion,
    headers: _headers,
  });

export const ApiService = {
  get,
  post,
  put,
  patch,
  delete: deleteRequest,
  setAuth,
  removeAuth,
  pureInstance,
  addErrorInterceptor,
  cleanApi
};
